export function getQueryParam(
  needle: string,
  query: string = window.location.search
): string | Array<string> | undefined {
  return parseQueryString(query)[needle]
}

/**
 * This function returns true if the queryParameter specified by `param` contains the `value`.
 * This lets queryPafameters contain multiple values.
 * e.g.: `?test=houseads,disableCmp,rubicon` ==> queryParamHas('test','rubicon') === true
 * @param param
 * @param value
 * @param query
 */
export function queryParamHas(
  param: string,
  value: string,
  query: string = window.location.search
): boolean {
  const queryValue = parseQueryString(query)[param]
  const queryValuesArray = Array.isArray(queryValue) ? queryValue : [queryValue]

  return queryValuesArray.indexOf(value) !== -1
}

export function parseQueryString(query: string): { [key: string]: any } {
  if (!query) {
    return {}
  }

  return query
    .replace(/^\?/, '')
    .split('&')
    .reduce((acc, criteria) => {
      let splitIndex = criteria.indexOf('=')
      splitIndex = splitIndex === -1 ? criteria.length : splitIndex

      let k = criteria.slice(0, splitIndex)
      const v = decodeURIComponent(criteria.slice(splitIndex + 1))

      if (/\[\]$/.test(k)) {
        k = k.replace('[]', '')
        acc[k] = acc[k] || []
        acc[k].push(v)
      } else {
        acc[k] = v || ''
      }

      return acc
    }, {})
}

export function formatQueryString(query: object): string {
  return Object.keys(query)
    .map((k) => {
      return Array.isArray(query[k])
        ? (query[k] as string[]).map((v) => `${k}[]=${v}`).join('&')
        : `${k}=${query[k]}`
    })
    .join('&')
}
